/* eslint-disable max-classes-per-file */

import { RequestListProductTypeEnums } from "@/types/product/account/history";
import { imageFallback } from "@/utils/error/imageError";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import {
  ContactDatePresenter,
  DayPlanDataPresenter,
  ListStepDataPresenter,
  RePaymentPresenter,
} from "./historyBookingCommonInterface";

class ExperienceLocationPresenter {
  areaId: number;

  areaName: string;

  areaSlug: string;

  cityId: number;

  cityName: string;

  citySlug: string;

  countryId: number;

  countryName: string;

  countrySlug: string;

  addressFull: string;

  constructor(response: any) {
    this.areaId = response?.areaId || "";
    this.areaName = response?.areaName || "";
    this.areaSlug = response?.areaSlug || "";
    this.cityId = response?.cityId || 0;
    this.cityName = response?.cityName || "";
    this.citySlug = response?.citySlug || "";
    this.countryId = response?.countryId || "";
    this.countryName = response?.countryName || "";
    this.countrySlug = response?.countrySlug || "";
    this.addressFull = response?.addressFull || "";
  }
}

export class ExperienceTotalTicketOfType {
  totalTickets: number;

  ticketType: string;

  constructor(response: any) {
    this.totalTickets = response?.totalTickets || 0;
    this.ticketType = response?.ticketType || "";
  }
}

export class ExperienceListDataPresenter {
  rsvnId: number;

  bookingInternalNo: string;

  pinCode: string;

  rsvnStatusId: number;

  bookingStatus: string;

  bookingDateOri: string;

  bookingDate: string;

  rsvnPaymentStatusId: number;

  paymentStatus: string;

  joiningDateOri: string;

  joiningDate: string;

  name: string;

  ticketName: string;

  slug: string;

  image: string;

  tier: string;

  ticketType: string;

  isGreenCertificate: boolean;

  dayPlan: DayPlanDataPresenter;

  contact: ContactDatePresenter;

  location: ExperienceLocationPresenter;

  payment: RePaymentPresenter;

  totalTicketOfType: ExperienceTotalTicketOfType[];
  // greenCertifications: any[]

  price: number;

  currency: string;

  dateCancelOri: string;

  productType: string;

  dateCancel: string;

  meetingPoint: string;

  constructor(response: any) {
    this.rsvnId = response?.rsvnId || 0;
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.pinCode = response?.pinCode || "";
    this.rsvnStatusId = response?.rsvnStatusId || 0;
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.bookingDateOri = response?.bookingDateOri || "";
    this.bookingDate = response?.bookingDate || "";
    this.rsvnPaymentStatusId = response?.rsvnPaymentStatusId || 0;
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.joiningDateOri = response?.joiningDateOri || "";
    this.joiningDate = response?.joiningDate || "";
    this.name = response?.name || "";
    this.ticketName = response?.ticketName || "";
    this.slug = response?.slug || "";
    this.image = response?.image || imageFallback;
    this.tier = response?.tier || "";
    this.ticketType = response?.ticketType || "";
    this.isGreenCertificate = response?.isGreenCertificate || false;
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.contact = new ContactDatePresenter(response?.contact);
    this.location = new ExperienceLocationPresenter(response?.location);
    this.payment = new RePaymentPresenter(response?.payment);
    this.totalTicketOfType = (response?.totalTicketOfType || []).map(
      (results: any) => new ExperienceTotalTicketOfType(results),
    );
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
    this.dateCancelOri = response?.dateCancelOri || "";
    this.productType = RequestListProductTypeEnums.EXPERIENCE;
    this.dateCancel = response?.dateCancel || "";
    this.meetingPoint = response?.meetingPoint || "";
  }
}

export class ExperienceListStepData extends ListStepDataPresenter<
  ExperienceListDataPresenter[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new ExperienceListDataPresenter(val)),
    );
  }
}
export class ResponseGetHistoryExperienceListPresenter extends ResponsePresenter<
  ExperienceListStepData[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new ExperienceListStepData(val)),
    );
  }
}
